import { useState } from "react";
import * as yup from "yup";
import useCart from "grandus-lib/hooks/useCart";
import { Form, Button, Alert } from "antd";
import { useFormikContext, Formik } from "formik";
import { get, isEmpty, toNumber } from "lodash";

import TextInput from "grandus-lib/components-atomic/form/TextInput";

const Isic = () => {
  const { mutateCart, applyIsic } = useCart();
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const formProps = {
    enableReinitialize: true,
    initialValues: {
      code: "",
      surname: "",
    },
    validationSchema: yup.object({
      code: yup
        .string()
        .nullable()
        .trim()
        .max(30, "ISIC číslo môže obsahovať max 30 znakov"),
      surname: yup.string().nullable().trim(),
    }),
    onSubmit: async (values, { setErrors }) => {
      const { code, surname } = values;

      try {
        setMessage("");
        setSuccess(false);
        const response = await applyIsic(surname, code);
        const success = toNumber(get(response, "status", false));
        setMessage(get(response, "message"));
        if (success) {
          await mutateCart(get(response, "data"), false);
          setSuccess(true);
        }
      } catch (error) {
        console.error("An unexpected error happened:", error);
        setErrors(error.data.message);
      }

      return false;
    },
  };

  return (
    <>
      {!isEmpty(message) ? (
        <Alert
          type={success ? "success" : "error"}
          message={message}
          style={{ marginBottom: "20px" }}
        />
      ) : null}
      <Formik {...formProps}>
        <IsicForm />
      </Formik>
    </>
  );
};

const IsicForm = () => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    dirty,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormikContext();
  return (
    <Form layout="inline" onFinish={handleSubmit}>
      <TextInput
        label="ISIC číslo"
        name="code"
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <TextInput
        label="Priezvisko"
        name="surname"
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <Form.Item>
        <Button
          style={{ marginRight: "10px" }}
          type="primary"
          htmlType="submit"
          loading={isValid && isSubmitting}
          disabled={!dirty || !isValid}
        >
          Použiť
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Isic;
